module.exports = __webpack_public_path__ + "static/first-87444de6ff178fe1c5137a57c728fbfb.jpg";